export default __webpack_public_path__ + "static/media/dilligence.f988b049.jpg";